module.exports = __webpack_public_path__ + "img/remove.9a890791.svg";